module.exports = __webpack_public_path__ + "img/mini.9810172b.png";